import React, { useEffect, useState } from "react";
import InvoicePage from "../../../../../entities/DashboardPage/AccountingModule/Invoice/InvoiceHome";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../../api/AuthService";
import { useAlert } from "../../../../../context/AlertContext";
// eslint-disable-next-line import/default

const Invoice = () => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState();
  const [page, setPage] = useState(1);
  const [recurringTemplateData, setRecurringTemplateData] = useState([]);
  const [totalRecurringTemplates, setTotalRecurringTemplates] = useState();
  const [recurringTemplatePage, setRecurringTemplatePage] = useState(1);
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getInvoice("", "", page);
    getRecurringInvoiceTemplates("", "", recurringTemplatePage)
  }, [page, recurringTemplatePage]);

  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteInvoice(id);
      if (result?.success) {
        showAlert("Invoice deleted successfully", "success")
        getInvoice();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result.message, "error")
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleDeleteRecurringTemplate = async (recurringTemplateId) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteRecurringInvoiceTemplate(recurringTemplateId);
      if (result?.success) {
        showAlert("Recurring invoice deleted successfully", "success")
        getRecurringInvoiceTemplates()
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getInvoice = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getInvoice(text, sort, page);
      if (result?.success) {
        setData(result?.data?.invoices);
        setTotal(result?.data?.total);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getRecurringInvoiceTemplates = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getRecurringInvoiceTemplates(text, sort, page);
      if (result?.success) {
        setRecurringTemplateData(result?.data?.templates);
        setTotalRecurringTemplates(result?.data?.total);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  }

  const handleDownload = async (item) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);
    try {
      const result = await AuthService.handleDownloadInvoice(item?._id);
      if (!result) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const blob = new Blob([result], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.${"pdf"}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleSearch = (text, sort) => {
    text ? getInvoice(text) : sort ? getInvoice("", sort) : null;
  };

  return (
    <InvoicePage
      handleDownload={handleDownload}
      loading={loading}
      total={total}
      page={page}
      setPage={setPage}
      data={data}
      handleDelete={handleDelete}
      handleSearch={handleSearch}
      handleDeleteRecurringTemplate={handleDeleteRecurringTemplate}
      recurringTemplateData={recurringTemplateData}
      recurringTemplatePage={recurringTemplatePage}
      totalRecurringTemplates={totalRecurringTemplates}
      setRecurringTemplatePage={setRecurringTemplatePage}
    />
  );
};

export default Invoice;
